import ABI from "./Legend.json";
const ADDRESS = "0x9D0C5e18dB1C28FB46D3C79c47336220b6bdf161";
export { ABI, ADDRESS };
